import React from "react";
import {ClientEntry} from "../ClientEntry";
import {NotFound} from "../../client/NotFound.tsx";
import "@repo/ui/styles.css";
import "../../index.css";


ClientEntry(<NotFound />)

